import type { ComposantEcran } from '../../app/ecrans.js';
import { EcranFacturation } from './EcranFacturation.js';
import { EcranPaiement } from './EcranPaiement.js';

/** Écrans fournis par le lot L57 au registre de la coquille : D08 (facturation du dossier) et M06 (régler ma quote-part). */
export const ecrans: Record<string, ComposantEcran> = { D08: EcranFacturation, M06: EcranPaiement };
